module.exports = __webpack_public_path__ + "img/astronaut4.4b39216f.jpg";